import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';
import { useBinVolumeGetter } from './data/bin-level-helpers';

const useStyles = makeStyles((theme) => {
  return {
    fill: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      background: theme.palette.gray[70],
      zIndex: 2,
    },
    container: {
      flex: 1,
      position: 'relative',
      overflow: 'hidden',
      margin: '0 1px',
    },
  };
});

export default function BinLevelReading({ level, fullTotal }) {
  const styles = useStyles();
  const binVolumeGetter = useBinVolumeGetter();

  const volume = binVolumeGetter(level);
  const fillHeightPercent = Math.min(volume / fullTotal * 100, 100);

  return (
    <div className={styles.container}>
      <div className={`${styles.fill}`} style={{ height: `${fillHeightPercent}%` }} />
    </div>
  );
}
